import { Link } from '@remix-run/react';
import { NetWorthListItemCategory, NetWorthListItemRouteSection } from '../netWorthItem.types';
import { ListItem } from '../../List';

export interface NetWorthListItem {
  heading: string;
  categories: NetWorthListItemCategory[];
  routeSection: NetWorthListItemRouteSection;
  categoryDisplayFunction: (v: NetWorthListItemCategory) => string;
}

export interface NetWorthListProps {
  items: NetWorthListItem[];
  getLinkTo?: (to: string) => string;
}

export function getNetWorthListLinkTo({
  category,
  getLinkTo,
  routeSection,
}: {
  category: NetWorthListItemCategory;
  getLinkTo?: (to: string) => string;
  routeSection: NetWorthListItemRouteSection;
}) {
  let subRoute = category;
  if (category === 'Note Receivable') {
    subRoute = 'note-receivable';
  } else if (category === 'Personal Property Item') {
    subRoute = 'personal-property-item';
  }
  const to =
    routeSection == NetWorthListItemRouteSection.Business ? `${routeSection}` : `${routeSection}/${subRoute}`;

  return getLinkTo?.(to) ?? to;
}

export const NetWorthList = ({ getLinkTo, items }: NetWorthListProps): JSX.Element => {
  return (
    <>
      {items.map((item, index) => {
        return (
          <div className="mt-8" key={index}>
            {item.heading && <h1 className="mb-3 text-[16px] font-bold text-darkMode-gray-medium">{item.heading}</h1>}
            <ul className="pl-2 md:pl-4">
              {item.categories.map((category) => {
                const to = getNetWorthListLinkTo({ category, getLinkTo, routeSection: item.routeSection });

                return (
                  <Link tabIndex={1} key={category} to={to} className="contents">
                    <ListItem
                      withChevron
                      className="!bg-transparent flex cursor-pointer justify-between py-2 !h-12 items-center text-white"
                    >
                      {item.categoryDisplayFunction(category)}
                    </ListItem>
                  </Link>
                );
              })}
            </ul>
          </div>
        );
      })}
    </>
  );
};
